import { useEffect, useRef, useState } from 'react';

import { useEntityChangeStore } from './stores/entity-change-store';

export const GLIMMER_DURATION_MS = 1_200;

// True for a short moment when the agent changes the given entity while this
// component is mounted. Fire-and-forget: components mounting after the change
// ignore it (changedAt <= mountedAt), and nothing is persisted or replayed.
// Pass undefined to disable (e.g. while the surface is in edit mode).
export const useEntityChangeGlimmer = (entityId: string | undefined): boolean => {
    const mountedAtRef = useRef(Date.now());
    const [isGlimmering, setIsGlimmering] = useState(false);
    const change = useEntityChangeStore((state) => (entityId === undefined ? undefined : state.changes.get(entityId)));

    useEffect(() => {
        if (change === undefined) {
            // The entity was disabled (e.g. edit mode) while glimmering; the timer
            // cleanup already ran, so reset explicitly instead of sticking on.
            setIsGlimmering(false);
            return;
        }
        if (change.changedAt <= mountedAtRef.current) return;
        setIsGlimmering(true);
        const timer = setTimeout(() => setIsGlimmering(false), GLIMMER_DURATION_MS);
        return () => clearTimeout(timer);
    }, [change]);

    return isGlimmering;
};
